/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class LaptopIcon extends BaseIcon {
  getChildren = () => [ <path d="M2,2v8h12V2H2z M13,9H3V3h10V9z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
